import * as SliderPrimitive from "@radix-ui/react-slider"
import { aIsMuted, aVolume, useAtom } from "~/atoms"
import { cn } from "~/utils"

export default function VolumeSlider({ className }: { className?: string }) {
  const [isMuted, setIsMuted] = useAtom(aIsMuted)
  const [volume, setVolume] = useAtom(aVolume)

  return (
    <div className={cn("group", className)}>
      <SliderPrimitive.Root
        className="relative flex w-full items-center focus-visible:ring-2 focus-visible:ring-white/10 focus-visible:ring-offset-2"
        max={1}
        step={0.1}
        value={isMuted ? [0] : [volume]}
        onValueChange={(v) => {
          setVolume(v[0])
          if (isMuted && v[0] > 0) {
            setIsMuted(false)
          }
        }}
      >
        <SliderPrimitive.Track className="flex h-12 w-full cursor-pointer items-center sm:h-14">
          <span className="relative h-1 w-full overflow-hidden rounded-full bg-white/20">
            <SliderPrimitive.Range className="absolute h-full bg-white" />
          </span>
        </SliderPrimitive.Track>
        <SliderPrimitive.Thumb className="flex h-12 w-3 items-center focus-visible:outline-none sm:h-14">
          <span className="h-3 w-3 rounded-full bg-background ring-offset-background transition-all duration-200 focus-visible:scale-100 focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent disabled:pointer-events-none disabled:opacity-50" />
        </SliderPrimitive.Thumb>
      </SliderPrimitive.Root>
    </div>
  )
}
